var map = {
	"./gong-xi-fa-cai-reg.m4a": [
		739,
		739
	],
	"./hong-bao-reg.m4a": [
		819,
		819
	],
	"./ni-hao-reg.m4a": [
		260,
		260
	],
	"./xie-xie-reg.m4a": [
		61,
		61
	],
	"./xin-nian-kuai-le-reg.m4a": [
		669,
		669
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 861;
module.exports = webpackAsyncContext;